import { FlowStepData } from "./FlowStepData";
import { BaseFlowStepRunner } from "./BaseFlowStepRunner";

export abstract class FlowStepRunner<T extends FlowStepData> extends BaseFlowStepRunner {
    stepData?: T;

    getFlowStepData(): FlowStepData {
        return this.stepData!;
    }
}
